import React, { useState } from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import cn from 'classnames';
import Button from 'components/Button';
import propTypes from './bundlesDetailsModalContentPropTypes';

const BundlesDetailsModalContent = ({
  description,
  extras,
  bundledAdditionalDrivers,
  additionalDriversPolicy,
  describedByID,
}) => {
  const [expanded, setExpanded] = useState(null);

  const handleExpandDrawer = (code) => () => {
    setExpanded((prev) => (prev === code ? null : code));
  };

  const renderItem = ({ code, name, detailed_description }) => (
    <React.Fragment key={code}>
      <Button
        button={false}
        type='button'
        ariaExpanded={expanded === code ? 'true' : 'false'}
        className={cn('modal-themed__drawer bundles-details-modal__drawer', {
          'modal-themed__drawer--expanded': expanded === code,
        })}
        onClick={handleExpandDrawer(code)}
      >
        {name}
      </Button>
      {expanded === code && (
        <div
          className='modal-themed__section modal-themed__gbo-content'
          dangerouslySetInnerHTML={sanitize(detailed_description)}
        />
      )}
    </React.Fragment>
  );

  return (
    <div id={describedByID} className='modal-themed__section bundles-details-modal'>
      {description && (
        <div className='bundles-details-modal__description' dangerouslySetInnerHTML={sanitize(description)} />
      )}

      <div className='modal-themed__drawer-container'>
        {extras && extras.map(renderItem)}
        {bundledAdditionalDrivers &&
          renderItem({
            code: 'addt_drv',
            name: i18n('bundles_card_additional_drivers', [bundledAdditionalDrivers]),
            detailed_description: additionalDriversPolicy?.policy_text,
          })}
      </div>
    </div>
  );
};

BundlesDetailsModalContent.propTypes = propTypes;

export default BundlesDetailsModalContent;
